import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children, testid }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} | AIROBOTCAMSTUDIO LTD`;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    const created = !canonical;
    const prev = created ? null : canonical.getAttribute("href");
    if (created) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${process.env.REACT_APP_SITE_URL}${window.location.pathname.replace(/\/+$/, "")}`);
    return () => {
      document.title = prevTitle;
      if (created) canonical.remove();
      else if (prev) canonical.setAttribute("href", prev);
    };
  }, [title]);

  return (
    <div data-testid={testid} className="min-h-screen bg-[#050505] text-white">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-2xl">
        <div className="mx-auto flex h-[64px] max-w-4xl items-center justify-between px-6">
          <a href="/" data-testid="legal-logo" className="font-display text-sm font-semibold tracking-[0.25em] text-white">
            AIROBOTCAM<span className="text-cyan-300">STUDIO</span>
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-[13px] font-medium text-cyan-200/70 transition-colors duration-300 hover:text-cyan-100"
          >
            <ArrowLeft size={15} /> Back to Home
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-16 lg:py-24">
        <p className="font-display text-[11px] font-medium uppercase tracking-[0.35em] text-cyan-300/90">Legal</p>
        <h1 className="font-display mt-4 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">{title}</h1>
        <p className="mt-3 text-xs uppercase tracking-[0.2em] text-white/55">{updated}</p>
        <div className="legal-body mt-12">{children}</div>
      </main>

      <footer className="border-t border-white/10">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-4 px-6 py-8">
          <p className="text-[11px] uppercase tracking-[0.2em] text-white/55">
            AIROBOTCAMSTUDIO LTD · UK Company No. 17410621
          </p>
          <div className="flex gap-6">
            <a href="/terms-of-service" data-testid="legal-nav-terms" className="text-xs text-cyan-200/70 transition-colors hover:text-cyan-100">Terms of Service</a>
            <a href="/privacy-policy" data-testid="legal-nav-privacy" className="text-xs text-cyan-200/70 transition-colors hover:text-cyan-100">Privacy Policy</a>
            <a href="/fair-use-policy" data-testid="legal-nav-fair-use" className="text-xs text-cyan-200/70 transition-colors hover:text-cyan-100">Fair Use Policy</a>
            <a href="/cookie-policy" data-testid="legal-nav-cookie" className="text-xs text-cyan-200/70 transition-colors hover:text-cyan-100">Cookie Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
